// Copyright (c) Bentley Systems
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./app/store";
import { BrowserRouter } from "react-router-dom";
import "@itwin/itwinui-react/styles.css"; // Import the styles here

export const ITwinLayout = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  );
};
